type StructureResponse = {
  success?: boolean
  data?: unknown
  message?: unknown
}

export const getStructureText = (response: StructureResponse): string => {
  if (response?.success === false) {
    throw new Error(typeof response.message === 'string' ? response.message : 'Erro ao gerar texto com IA')
  }
  const legacyMessage = response?.message
  const text = response?.data ?? (
    typeof legacyMessage === 'object' && legacyMessage !== null && 'data' in legacyMessage
      ? (legacyMessage as {data: unknown}).data
      : undefined
  )
  if (typeof text !== 'string' || !text.trim()) {
    throw new Error('A IA retornou uma resposta sem texto válido')
  }
  return text
}
